import { cn } from '@plato/ui/util/classes';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { NewEventButton } from './new-event-button.tsx';

export type Props = {
    day: string;
    ownerId: string;
    className?: string;
};

/** A day without events: says so, and offers to create one. */
export function EmptyDay({ day, ownerId, className }: Props): ReactNode {
    const { t } = useTranslation('events');

    return (
        <div className={cn('flex flex-col gap-cozy', className)}>
            <span className="text-center text-body text-content-weak">{t('empty_day__title')}</span>
            <NewEventButton day={day} ownerId={ownerId} />
        </div>
    );
}
